import { handleActions } from 'redux-actions'
import * as type from './type'


export const initialState = {
    versionSummary: [],
    error: null,
    fetching: false,

}


export default handleActions({
    [type.GET_VERSION_SUMMARY_REQUEST]: (state, action) => {
        return {
            ...state,
            error: null,
            fetching: true,
        }
    },
    [type.GET_VERSION_SUMMARY_SUCCESS]: (state, action) => {
        const { versionSummary } = action.payload
        return {
            ...state,
            versionSummary,
            fetching: false,
        }
    },
    [type.GET_VERSION_SUMMARY_ERROR]: (state, action) => {
        const { error } = action.payload
        return {
            ...state,
            error,
            fetching: false,
        }
    },


}, initialState)



// WEBPACK FOOTER //
// ./src/modules/process/state/version-summary/reducer.js